import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { deactivateUser } from '../store';

import { useProfileContext } from '@/features/context/ProfileContext';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';

import { selectProfileWalletsByUserId } from '@/store/selectors';

export const DeleteUser = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { user } = useProfileContext();

  const profileWalletsState = useAppSelector(
    (state) => user?.userId && selectProfileWalletsByUserId(state, user.userId)?.state,
  );

  const profileWallets = useMemo(
    () =>
      profileWalletsState && profileWalletsState.length
        ? profileWalletsState.map((profileWallets) => profileWallets.state)
        : [],
    [profileWalletsState],
  );

  const walletWithSolde = useMemo(
    () =>
      profileWallets?.reduce(
        (acc, currentProfileWallet) => {
          if (currentProfileWallet?.wallet?.solde !== 0.0) {
            return { canDeleteUser: false, walletName: currentProfileWallet?.wallet?.eventName || '' };
          }
          return acc;
        },
        { canDeleteUser: true, walletName: '' },
      ),
    [profileWallets],
  );

  const handleDeleteUser = () => {
    user?.userId && dispatch(deactivateUser(user.userId));
    toggleDeleteUserModal();
  };

  const toggleDeleteUserModal = () => {
    DeleteUserModal.toggle();
  };

  const name = user?.title?.toUpperCase() + ' ' + user?.firstname + ' ' + user?.lastname?.toUpperCase();

  const modalDescription = walletWithSolde.canDeleteUser
    ? t('pages.currentProfiles.profile.modalDeleteUser.delete.description')
    : t('pages.currentProfiles.profile.modalDeleteUser.noDelete.description', {
        nameWallet: walletWithSolde.walletName,
        name,
      });

  const DeleteUserModal = useConfirmationDialog({
    title: t('pages.currentProfiles.profile.modalDeleteUser.title'),
    description: modalDescription,
    confirm: {
      action: handleDeleteUser,
      color: 'danger',
      label: t('pages.currentProfiles.profile.actions.deleteUser'),
      disabled: !walletWithSolde.canDeleteUser,
    },
    cancel: { label: t('pages.modal.closebtn') },
  });

  return (
    <>
      <Button id="delete-user-btn-delete" variant="secondary" color="danger" onClick={toggleDeleteUserModal}>
        {t('pages.currentProfiles.actionUser.delete')}
      </Button>
      <DeleteUserModal.ConfirmationDialog />
    </>
  );
};
